import { createProcessingSelector } from 'store/loading/selectors';
import { GET_DEEP_LINK } from 'store/deepLink/actionTypes';

import { useSelector } from 'hooks';

import * as S from './styled';

import { useGetImages } from './useGetImages';
import ScanQrCode from '../ScanQrCode';

const PlanInfo = ({ isMobileDevice, deepLinkUrl }: { isMobileDevice: boolean; deepLinkUrl: string }) => {
    const isLoading: boolean = useSelector(createProcessingSelector([GET_DEEP_LINK]));
    const { desktop, mobile } = useGetImages();

    return (
        <S.Wrapper isMobileDevice={isMobileDevice} data-locator="deeplinkContainer">
            <S.InnerWrapper>
                {isMobileDevice ? (
                    <S.MobileImg alt="Plan information" src={mobile} isMobileDevice={isMobileDevice} />
                ) : (
                    <>
                        <ScanQrCode isLoading={isLoading} deepLinkUrl={deepLinkUrl} />
                        <S.Desktop alt="Plan information" src={desktop} />
                    </>
                )}
            </S.InnerWrapper>
        </S.Wrapper>
    );
};

export default PlanInfo;
